import { useEffect, useState } from "react";
import { MessageSquareHeart, Pencil } from "lucide-react";
import { toast } from "sonner";
import { Btn } from "@/components/Btn";
import { usePrefs, useSavePrefs } from "@/lib/store";

export function SessionPrepCard() {
  const { data: prefs } = usePrefs();
  const save = useSavePrefs();
  const saved = prefs?.sessionNote ?? "";
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(saved);
  useEffect(() => { if (!open) setText(saved); }, [saved, open]);
  const who = prefs?.therapistName?.trim() || "your psychologist";
  const commit = async () => {
    await save.mutateAsync({ sessionNote: text.trim() });
    setOpen(false);
    toast.success(text.trim() ? "Saved for your next session" : "Note cleared");
  };
  return (
    <div className="tf-card p-5 mt-6" data-testid="session-prep-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 font-bold text-t-on"><MessageSquareHeart size={18} className="text-t-brand" /> Next session</p>
          <p className="text-sm text-t-muted mt-0.5">What you'd like to talk about. It's added to your next report to {who}, then cleared.</p>
        </div>
        {!open && saved ? <button onClick={() => setOpen(true)} className="text-t-muted hover:text-t-brand transition-colors" aria-label="Edit note" data-testid="session-prep-edit"><Pencil size={16} /></button> : null}
      </div>
      {open ? (
        <>
          <textarea className="tf-input mt-3" value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} autoFocus
            placeholder="e.g. The argument with Mum on Sunday, why criticism at work hits so hard…" data-testid="session-prep-input" />
          <div className="flex gap-3 mt-3">
            <Btn size="md" label="Save" loading={save.isPending} onClick={commit} testId="session-prep-save" />
            <Btn size="md" variant="ghost" label="Cancel" onClick={() => setOpen(false)} testId="session-prep-cancel" />
          </div>
        </>
      ) : saved ? (
        <p className="mt-3 text-t-on whitespace-pre-line rounded-2xl bg-t-surface2 px-4 py-3" data-testid="session-prep-text">{saved}</p>
      ) : (
        <button onClick={() => setOpen(true)} className="mt-3 w-full rounded-2xl border border-dashed border-t-border2 px-4 py-3 text-left text-sm font-semibold text-t-brand hover:border-t-brand transition-colors" data-testid="session-prep-add">
          + Add something to talk about
        </button>
      )}
    </div>
  );
}
